import { render, staticRenderFns } from "./TextAlignLeft.vue?vue&type=template&id=65d0b3d3&scoped=true&"
import script from "./TextAlignLeft.vue?vue&type=script&lang=js&"
export * from "./TextAlignLeft.vue?vue&type=script&lang=js&"
import style0 from "./TextAlignLeft.vue?vue&type=style&index=0&id=65d0b3d3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d0b3d3",
  null
  
)

export default component.exports